import {
    Invoice,
    IToastContextProps,
    LEDGER_DIALOG_PAPER_PROPS,
    LEDGER_DIALOG_SX,
    RecordDiscountDialog,
} from '@enter/core';
import React from 'react';
import { IDialogContextProps } from 'services';
import { ClaimStore } from 'stores/claim.store';
import { equalsFilter } from 'stores/util';

type ShowRecordDiscountDialogArgs = {
    dialogContext: IDialogContextProps;
    toastContext: IToastContextProps;
    claimStore: ClaimStore;
    claimId: string;
    fromDos?: string;
    invoice: Invoice;
    onSuccess?: () => void;
};

/** Opens the patient-statement "Record discount" modal, applied to a single claim's invoice. */
export const showRecordDiscountDialog = (args: ShowRecordDiscountDialogArgs): void => {
    const { dialogContext, toastContext, claimStore, claimId, fromDos, invoice, onSuccess } = args;

    const handleClose = (): void => {
        dialogContext.hideDialog();
    };

    const handleSuccess = (): void => {
        handleClose();
        onSuccess?.();
    };

    dialogContext.showDialog({
        props: {
            onClose: handleClose,
            disableBackdropClick: true,
            disableEscapeKeyDown: true,
            PaperProps: LEDGER_DIALOG_PAPER_PROPS,
            sx: LEDGER_DIALOG_SX,
        },
        Component: (
            <RecordDiscountDialog
                fixedClaim={{
                    id: claimId,
                    fromDos,
                    balance: Number(invoice.remainingAmountDue?.amount ?? 0),
                }}
                fixedInvoice={invoice}
                onInvoiceUpdated={updated => claimStore.upsertInvoice(updated)}
                onClose={handleClose}
                onSuccess={handleSuccess}
                dialogContext={dialogContext}
                toastContext={toastContext}
                equalsFilter={equalsFilter}
            />
        ),
    });
};
